import React from 'react';
import styles from './HighlightButtonsGroup.module.scss';
import { useApplicationState } from '../../hooks/common/use-application-state';
import { saveSelection } from '../../utils/selection-utils';
import { updateCommentBox, updateCommentList } from '../../redux/comments/methods';

const HighlightButtonsGroup =  () => {
  const {
    commentButtonPosition,
    hiddenCommentButton
  } = useApplicationState((state) => ({ 
    commentButtonPosition: state.commentsData.commentButtonPosition,
    hiddenCommentButton: state.commentsData.hiddenCommentButton,
  }));

  const saveAndRestoreSelection = () => {
    const savedSelection = saveSelection();
    updateCommentBox(false);
    // updateCommentList(true);
  }

  return (
    <div hidden={hiddenCommentButton}
      style={{
        position: commentButtonPosition.position,
        left: commentButtonPosition.left,
        top: commentButtonPosition.top,
        width: `${commentButtonPosition.widthInPixel}px`,
        height: `${commentButtonPosition.heightInPixel}px`
      }}
    >
      <div className={styles.buttons_group}>
        <button
          onClick={saveAndRestoreSelection}
          className={styles.comment_btn}
        >
          Comment
        </button>
        <div className={styles.down_arrow_tip}></div>
      </div>
    </div>
  )
}

export default HighlightButtonsGroup;
